import { useCallback, useRef } from 'react';
import type { ApiClientResponseError, ResponseErrorDataObject } from 'common/services';
import { Alert } from '../alert';
import { AxiosErrorHandler } from '../axios-error-handler';
import { Col } from '../col';
import { FormActions } from '../form';
import { Modal } from '../modal';
import { QRCode, type QrCodeRef } from '../qr-code';
import { Row } from '../row';

type P = {
  alerts: Array<{ description: string }>;
  error?: ApiClientResponseError<ResponseErrorDataObject> | null;
  fileName: string;
  isLoading?: boolean;
  isOpened: boolean;
  onCancel: () => void;
  qrCodeValue: string;
  title: string;
};

const QrCodeModal = ({ alerts, error, fileName, isLoading, isOpened, onCancel, qrCodeValue, title }: P) => {
  const qrCodeRef = useRef<QrCodeRef>(null);

  const handleDownload = useCallback(() => {
    qrCodeRef.current?.download({ fileName });
  }, [fileName]);

  return (
    <Modal isOpened={isOpened} onCancel={onCancel} title={title}>
      <AxiosErrorHandler actions={false} error={error}>
        <Modal.HugContent>
          <Row gutter={[0, 'ms']}>
            <Col justifyContent="center" span={24}>
              <QRCode isLoading={isLoading} ref={qrCodeRef} size={240} value={qrCodeValue} />
            </Col>
            <Col span={24}>
              <Row gutter={[0, 'ms']}>
                {alerts.map(({ description }) => (
                  <Col key={description} span={24}>
                    <Alert description={description} />
                  </Col>
                ))}
              </Row>
            </Col>
            <Col span={24}>
              <Modal.HugContent.Footer>
                <FormActions
                  right={{
                    children: 'Back',
                    onClick() {
                      onCancel();
                    },
                  }}
                  submit={{
                    children: 'Download',
                    onClick: handleDownload,
                  }}
                />
              </Modal.HugContent.Footer>
            </Col>
          </Row>
        </Modal.HugContent>
      </AxiosErrorHandler>
    </Modal>
  );
};

export default QrCodeModal;
